global.serviceURL = "http://localhost:8090/";

global.downcommand = {
	"0x11": "设置设备属性",
	"0x12": "设置阶梯气价",
	"0x13": "充值",
	"0x13": "充值历史",
	"0x24": "月用气历史",
	"0x15": "设置用气时段",
	"0x17": "设备注册",
	"0x18": "特征常数操作",
	"0x19": "设置采集时间",
	"0x1E": "计费方式重置",
	"0x1F": "重置",
	"0xE1": "开关阀操作",
};
global.upcommand = {
	"0x81": "故障报警",
	"0x87": "管道环境参数",
	"0x83": "设备状态",
	"0x84": "阀门开关记录",
	"0x85": "计量状态",
	"0x86": "日用气历史",
	"0xE2": "安检",
	"0x71": "清除故障",
	"0x28": "设备特征常数",
	"0x24": "月用气历史",
};

global.commandop = {
	运行参数: {
		up: "0x11",
		down: "0x11"
	},
	计量状态: {
		up: "0x85",
		down: ""
	},
	充值历史: {
		up: "0x13",
		down: ""
	},
	阀门控制: {
		up: "0x84",
		down: "0xE1"
	},
	报警事件: {
		up: "0x81",
		down: ""
	},
	安检周期: {
		up: "",
		down: "0xE2"
	},
	设备状态: {
		up: "0x83",
		down: ""
	},
	安全用气: {
		up: "",
		down: "0x15"
	},
	用气设备注册: {
		up: "",
		down: "0x17"
	},
	禁用解除: {
		up: "",
		down: "0x71"
	},
	特征值: {
		up: "0x28",
		down: "0x18"
	},
	温压采集: {
		up: "0x87",
		down: "0x19"
	},
	日用气记录: {
		up: "0x86",
		down: ""
	},
	月用气历史: {
		up: "0x24",
		down: ""
	},
	计费方式重置: {
		up: "",
		down: "0x1E"
	},
};
global.commandop1 = {
	设备重置: {
		up: "",
		down: "0x1F"
	},
	设备运行参数: {
		up: "0x11",
		down: "0x11"
	},
	安检周期: {
		up: "",
		down: "0xE2"
	},
	安全用气: {
		up: "",
		down: "0x15"
	},
	设备注册: {
		up: "",
		down: "0x17"
	},
	特征值: {
		up: "0x28",
		down: "0x18"
	},
	温度采集: {
		up: "0x87",
		down: "0x19"
	},
	计费方式重置: {
		up: "",
		down: "0x1E"
	},
};
global.commandop2 = {
	阀门控制: {
		up: "0x84",
		down: "0xE1"
	},
	智能管理阀标定: {
		up: "0xA4",
		down: "0xA4"
	},
	禁用解除: {
		up: "",
		down: "0x71"
	},
};
global.commandop3 = {
	计量状态: {
		up: "0x85",
		down: ""
	},
	充值: {
		up: "0x13",
		down: "0x13"
	},
	设备状态: {
		up: "0x83",
		down: ""
	},
	使用记录: {
		up: "0x86",
		down: ""
	},
	月用气历史: {
		up: "0x24",
		down: ""
	},
};
global.commandop4 = {
	报警事件: {
		up: "0x81",
		down: ""
	}
};
//global.commandopProduce1 = { '设备重置': { "up": "", "down": "0x1F" }, '安检周期': { "up": "", "down": "0xE2" }, '计费方式重置': { "up": "", "down": "0x1E" } }
//global.commandopProduce2 = { '禁用解除': { "up": "", "down": "0x71" } }
//global.commandopProduce3 = { '充值': { "up": "0x13", "down": "0x13" }, '设备状态': { "up": "0x83", "down": "" }, '使用记录': { "up": "0x86", "down": "" } }
//global.commandopProduce4 = { '报警事件': { "up": "0x81", "down": "" } }
global.commandopProduce1 = {
	设备重置: {
		up: "",
		down: "0x1F"
	},
	设备运行参数: {
		up: "0x11",
		down: "0x11"
	},
	安检周期: {
		up: "",
		down: "0xE2"
	},
	安全用气: {
		up: "",
		down: "0x15"
	},
	设备注册: {
		up: "",
		down: "0x17"
	},
	智能管理阀标定: {
		up: "0xA4",
		down: "0xA4"
	},
	特征值: {
		up: "0x28",
		down: "0x18"
	},
	温度采集: {
		up: "0x87",
		down: "0x19"
	},
	计费方式重置: {
		up: "",
		down: "0x1E"
	},
};
global.commandopProduce2 = {
	阀门控制: {
		up: "0x84",
		down: "0xE1"
	},
	禁用解除: {
		up: "",
		down: "0x71"
	},
};
global.commandopProduce3 = {
	计量状态: {
		up: "0x85",
		down: ""
	},
	充值: {
		up: "0x13",
		down: "0x13"
	},
	设备状态: {
		up: "0x83",
		down: ""
	},
	使用记录: {
		up: "0x86",
		down: ""
	},
	月用气历史: {
		up: "0x24",
		down: ""
	},
};
global.commandopProduce4 = {
	报警事件: {
		up: "0x81",
		down: ""
	}
};
// global.address.type = {'省份': '0', '地级市': '1', '县级市': '2', '行政区': '3', '小区': '4', '楼栋': '5', '单元': '6', '户号': '7'}

global.addresstype = [
	"省份",
	"地级市",
	"县级市",
	"行政区",
	"小区",
	"楼栋",
	"单元",
	"户号",
];

global.personnelType = ["安全负责人", "工程人员", "营业员"];

global.goveringbodytype = ["总公司", "分公司", "营业部", "维修部"];

// 设备通讯方式
global.communicateType = ["WIFI", "NB", "NB(电信)"];

// 安检项目
global.checkItem = {
	管道: {
		key: "piping",
		value: "管道",
		option: ["正常", "异常"]
	},
	燃气表: {
		key: "meter",
		value: "燃气表",
		option: ["正常", "异常"]
	},
	软管: {
		key: "hose",
		value: "软管",
		option: ["正常", "异常"]
	},
	波纹管: {
		key: "bellows",
		value: "波纹管",
		option: ["正常", "异常"]
	},
	燃气灶: {
		key: "stove",
		value: "燃气灶",
		option: ["正常", "异常"]
	},
	检漏: {
		key: "leak",
		value: "检漏",
		option: ["正常", "异常"]
	},
	安检宣传单: {
		key: "propaganda",
		value: "安检宣传单",
		option: ["已发放", "未发放"],
	},
};
// 安检结果
global.checkResult = {
	"0": "正常安检",
	"1": "到访不遇",
	"2": "拒绝安检",
	"3": "安检整改",
};
// 报警信息
global.errorMsgParam = {
	"4": {
		name: "计量装置故障(磁开关损坏)",
		factoryRatio1: "标定比例系数1(%)",
		factoryRatio2: "标定比例系数2(%)",
		factoryRatio3: "标定比例系数3(%)",
		factoryRatio4: "标定比例系数4(%)",
		currentRatio1: "比例系数1(%)",
		currentRatio2: "比例系数2(%)",
		currentRatio3: "比例系数3(%)",
		currentRatio4: "比例系数4(%)",
	},
	"15": {
		name: "强磁干扰"
	},
	"16": {
		name: "管道超压",
		pipePressure: "管道绝对压力值(Pa)",
		atmosphericPressure: "大气压力值(Pa)",
	},
	"17": {
		name: "管道欠压",
		pipePressure: "管道绝对压力值(Pa)",
		atmosphericPressure: "大气压力值(Pa)",
	},
	"14": {
		name: "软管破损",
		pipePressure: "管道绝对压力值(Pa)",
		atmosphericPressure: "大气压力值(Pa)",
		velocity: "流速值(L/h)",
	},
	"18": {
		name: "环境温度过高",
		pipeTemperature: "管道温度值(℃)",
		indoorTemperature: "板载温度值(℃)",
		velocity: "流速值(L/h)",
	},
	"7": {
		name: "流量过载",
		velocity: "流速值(L/h)"
	},
	"10": {
		name: "恒流超量",
		velocity: "恒流速值(L/h)",
		interval: "恒流时长(s)",
	},
	"20": {
		name: "计量精度下降",
		factoryRatio1: "标定比例系数1(%)",
		factoryRatio2: "标定比例系数2(%)",
		factoryRatio3: "标定比例系数3(%)",
		factoryRatio4: "标定比例系数4(%)",
		currentRatio1: "比例系数1(%)",
		currentRatio2: "比例系数2(%)",
		currentRatio3: "比例系数3(%)",
		currentRatio4: "比例系数4(%)",
		velocity: "流速值(L/h)",
		param: "偏差值(%)",
	},
	"23": {
		name: "异常小流量",
		velocity: "最后流速值(L/h)",
		interval: "持续时长(s)",
	},
	"9": {
		name: "长时间未用气"
	},
	"6": {
		name: "气表损坏"
	},
	"13": {
		name: "安检到期"
	},
	"2": {
		name: "余量不足"
	},
	"8": {
		name: "电池欠压"
	},
	"12": {
		name: "报警器报警"
	},
	"21": {
		name: "压力传感器故障"
	},
	"24": {
		name: "板载传感器故障"
	},
	"22": {
		name: "存储故障"
	},
	"25": {
		name: "在非用气时段使用",
		velocity: "流量值(L/h)"
	},
	"26": {
		name: "非注册设备",
		velocity: "流量值(L/h)"
	},
	"27": {
		name: "拆表报警",
		lastTime: "末次使用时间",
		pipePressure: "管道压力(Pa)",
		atmosphericPressure: "大气压力(Pa)",
		interval: "停电时长(s)",
		isValveClosed: "阀门状态",
		param: "拆表类型",
		params: {
			"1": "掉电时间过长",
			"2": "开阀拆表(压力过低超时)",
			"3": "关阀拆表(压力过低并重检后仍然低",
		},
	},
	"0": {
		name: "平台下发禁用"
	},
	"1": {
		name: "阶梯计费超出有效期"
	},
	"3": {
		name: "欠费"
	},
	"5": {
		name: "阀门故障",
		velocity: "流速值(L/h)"
	},
	"11": {
		name: "恒流超时"
	},
	"19": {
		name: "地震"
	},
};
// 维修结果
global.repairResult = {
	"0": "正常维修",
	"1": "正常维修更换",
	"2": "拒绝维修",
	"3": "到访不遇",
};
// 换表需重新下发的命令字
global.redownCommand = [{
		commandId: "0x17",
		commandName: "用气设备注册"
	},
	{
		commandId: "0x19",
		commandName: "温压采集时间设置"
	},
	{
		commandId: "0x11",
		commandName: "运行参数"
	},
	{
		commandId: "0x15",
		commandName: "安全用气"
	},
	{
		commandId: "0xE2",
		commandName: "安检周期"
	},
];

// 安全阀报文类型
global.valveMessageTypeEnum = {
	abnormalFlowUpload: "大设备启动流量（旧）",
	pipeStatusUpload: "管道状态",
	diffuseRecordUpload: "放散记录",
	pipeCapacityRecordUpload: "管容记录",
	regularUpload: "定时上传",
	fluctuatePressureUpload: "压力波动",
	runParameterSet: "参数设置",
	errorTrig: "报警触发",
	errorClear: "报警清除",
	bigFlowUpload: "大设备启动流量",
	valveOperationUpload: "分段用气量",
	deviceReset: "设备重置",
	gasAvailable: "可用气量设置",
	gasSet: "表底数设置"
};

global.valveMessageTypeEnum2 = {
	valveOpenDuration: "开阀定时时长",
	valveClose: "立即关阀",
	airTightness: "气密性检测监测",
	temperature: "温度异常监测",
	abnormalPressure: "压力异常",
	leakCheck: "泄漏",
	leakSensor: "泄漏传感器失效",
	server: "服务器信息配置",
	rotation: "回转周期统计算法参数",
	powerMax: "设备注册最大功率",
	pay: "远程缴费充值气量",
	heartbeat: "心跳检测设置",
	collection: "原始数据采集"
};

//天然气热值
global.gasApplianceHeatingValue = 36;
//用气设备注册系数
global.gasApplianceRatio = 1.2;
//阶梯气价结算类型
global.ladderPriceSettleType = {
	0: "未用",
	1: "按月",
	2: "按季度",
	3: "按年",
	4: "按开始结束时间",
	5: "按天数",
};
/**************************************时间格式化处理************************************/
global.dateFtt = function(fmt, date) {
	if (!(date instanceof Date)) {
		console.log("时间格式错误: " + JSON.stringify(date));
		return "";
	}
	var o = {
		"M+": date.getMonth() + 1, //月份
		"d+": date.getDate(), //日
		"h+": date.getHours(), //小时
		"m+": date.getMinutes(), //分
		"s+": date.getSeconds(), //秒
		"q+": Math.floor((date.getMonth() + 3) / 3), //季度
		S: date.getMilliseconds(), //毫秒
	};
	if (date.getFullYear() == "1970") {
		return "";
	}
	if (/(y+)/.test(fmt))
		fmt = fmt.replace(
			RegExp.$1,
			(date.getFullYear() + "").substr(4 - RegExp.$1.length)
		);
	for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt))
			fmt = fmt.replace(
				RegExp.$1,
				RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
			);
	return fmt;
};

//增加月
global.AddMonths = function(date, value) {
	date.setMonth(date.getMonth() + value);
	return date;
};
//增加天
global.AddDays = function(date, value) {
	date.setDate(date.getDate() + value);
	return date;
};
//增加时
global.AddHours = function(date, value) {
	date.setHours(date.getHours() + value);
	return date;
};

if (window.location.href.indexOf('/mobile') == -1) {
	global.userInfo = (function() {
		var that = this;
		$.ajax({
			url: "/api/getUserInfo?refresh=1",
			contentType: "application/json",
			type: "get",
			dataType: "json",
			async: false,
			success: function(data) {
				console.log(data);
			},
			error: function(textStatus) {
				that.$Notice.error({
					title: "异常",
					desc: "接口调用异常",
				});
			},
			complete: function(XMLHttpRequest, textStatus) {},
		});
	})();

	// 用气类型
	// { "1": '家庭用气', "2": '工业用气', "0": '其他用气'}
	global.gasType = (function() {
		var that = this;
		var result = {};
		$.ajax({
			url: "/api/ladderPrice/selectAllGasTypeEnum",
			contentType: "application/json",
			type: "get",
			dataType: "json",
			async: false,
			success: function(data) {
				if (data.errorCode != 0) {
					// that.$Modal.error({
					// 	title: "提示",
					// 	content: data.errorInfo
					// });
					// return;
				} else {
					result = data.body.fomat;
				}
				console.log(data);
			},
			error: function(textStatus) {
				// that.$Notice.error({
				// 	title: "异常",
				// 	desc: "接口调用异常"
				// });
			},
			complete: function(XMLHttpRequest, textStatus) {},
		});
		return result;
	})();

	// 设备厂家
	// ['西美', '山城']
	global.manufacturer = (function() {
		var that = this;
		var result = [];
		$.ajax({
			url: "/api/dictionary/selectEnumPage?page=0&pageAmount=1",
			contentType: "application/json",
			type: "post",
			dataType: "json",
			data: JSON.stringify({
				dictionaryPid: "manufacturer",
			}),
			async: false,
			success: function(data) {
				if (data.errorCode != 0) {
					// that.$Modal.error({
					// 	title: "提示",
					// 	content: data.errorInfo
					// });
					// return;
				} else {
					data.body.resultList.map((item) => {
						result.push(item.dictionaryName);
					});
				}
				console.log(data);
			},
			error: function(textStatus) {
				// that.$Notice.error({
				// 	title: "异常",
				// 	desc: "接口调用异常"
				// });
			},
			complete: function(XMLHttpRequest, textStatus) {},
		});
		return result;
	})();

	// 设备规格
	//['G2.5']
	global.specifications = (function() {
		var that = this;
		var result = [];
		$.ajax({
			url: "/api/dictionary/selectEnumPage?page=0&pageAmount=1",
			contentType: "application/json",
			type: "post",
			dataType: "json",
			data: JSON.stringify({
				dictionaryPid: "specifications",
			}),
			async: false,
			success: function(data) {
				if (data.errorCode != 0) {
					// that.$Modal.error({
					// 	title: "提示",
					// 	content: data.errorInfo
					// });
					// return;
				} else {
					data.body.resultList.map((item) => {
						result.push(item.dictionaryName);
					});
				}
				console.log(data);
			},
			error: function(textStatus) {
				// that.$Notice.error({
				// 	title: "异常",
				// 	desc: "接口调用异常"
				// });
			},
			complete: function(XMLHttpRequest, textStatus) {},
		});
		return result;
	})();

	// 设备类型
	// { "1": '家用燃气安全燃气表', "2": '工业用安全燃气表' }
	global.meterType = (function() {
		var that = this;
		var result = {};
		$.ajax({
			url: "/api/meterType/selectEnumPage?page=0&pageAmount=1",
			contentType: "application/json",
			type: "post",
			dataType: "json",
			data: JSON.stringify({}),
			async: false,
			success: function(data) {
				if (data.errorCode != 0) {
					// that.$Modal.error({
					// 	title: "提示",
					// 	content: data.errorInfo
					// });
					// return;
				} else {
					let payResult = {};
					data.body.resultList.map((item) => {
						result[item.meterTypeId.toString()] = item.meterTypeName;
						payResult[item.meterTypeId + ""] = item.meterTypePayType;
					});
					global.meterTypePayType = payResult;
				}
				console.log(data);
			},
			error: function(textStatus) {
				// that.$Notice.error({
				// 	title: "异常",
				// 	desc: "接口调用异常"
				// });
			},
			complete: function(XMLHttpRequest, textStatus) {},
		});

		console.log("result: " + JSON.stringify(result));
		return result;
	})();
}

global.profileTest = {
	timeoutShutdown: {
		field: [{
			name: "timeout",
			type: "number",
			cn: "超时时间",
			default: 45,
			unit: "分钟",
			min: 10,
			max: 360,
		}, ],
		cn: "超时关阀时间设置",
	},
	continuousReminder: {
		field: [{
			name: "isopen",
			type: "enum",
			cn: "功能开关",
			default: 0,
			enum: [{
					name: "open",
					cn: "开",
				},
				{
					name: "close",
					cn: "关",
				},
			],
		}, ],
		cn: "续时提醒开关",
	},
	meterInspection: {
		field: [{
			name: "isopen",
			type: "enum",
			cn: "功能开关",
			default: 0,
			enum: [{
					name: "open",
					cn: "开",
				},
				{
					name: "close",
					cn: "关",
				},
			],
		}, ],
		cn: "表具监测开关",
	},
	abnormalFlow: {
		field: [{
			name: "threshold",
			type: "number",
			cn: "最大流量增量阈值",
			default: 0.8,
			disabled: "true",
			unit: "m³/h",
		}, ],
		cn: "设置最大流量增量阈值",
	},
	constantCurrentOverload: {
		field: [{
			name: "threshold",
			type: "number",
			cn: "恒流超量阈值",
		}, ],
		cn: "恒流超量",
	},
	abnormalBigFlow: {
		field: [{
			name: "threshold",
			type: "number",
			cn: "异常大流量阈值",
		}, ],
		cn: "设置异常大流量阈值",
	},
	abnormalPressure: {
		field: [{
				name: "qthreshold",
				type: "number",
				cn: "欠压阈值",
				min: 600,
				max: 1600,
				unit: "Pa",
			},
			{
				name: "cthreshold",
				type: "number",
				cn: "超压阈值",
				min: 2600,
				max: 20000,
				unit: "Pa",
			},
		],
		cn: "设置压力阈值",
	},
	abnormalTemperature: {
		field: [{
			name: "threshold",
			type: "number",
			cn: "温度异常阈值",
		}, ],
		cn: "设置温度异常阈值",
	},
	constantCurrentTimeout: {
		field: [{
			name: "qthreshold",
			type: "number",
			cn: "阈值",
			min: 20,
			max: 240,
			unit: "分钟",
		}, ],
		cn: "设置恒流超时阈值",
	},
};
